"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
var assert_1 = require("./assert");
var coerce_1 = require("./coerce");
var create = function (guard, value, coercer) {
    if (coercer === void 0) { coercer = function (guard, path, value) { return value; }; }
    var coercedValue = (0, coerce_1.coerce)(guard, value, coercer);
    (0, assert_1.assert)(guard, coercedValue);
    return coercedValue;
};
exports.create = create;
